<template>
    <div class="relevant-search">
        <strong>相关搜索</strong>
        <p>
            <a href="javascript:;" v-for="(item,index) in relationSearch" :key="index" @click="goSearchFromRelevant(item);countAd(4519)">{{item}}</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'RelevantSearch',
        props: {
            relationSearch: {
                type: Array,
                default: () => ({})
            }
        },
        methods: {
            goSearchFromRelevant(item) {
                window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${item}`)
            }    
        },
    }
</script>

<style lang="scss" scoped>
.relevant-search {
    margin-top: 20px;
    margin-bottom: 25px;
    strong {
        font-size: 14px;
        color: #333;
    }
    p {
        a {
            color: #259;
            text-decoration: underline;
            display: inline-block;
            width: 170px;
            margin-top: 10px;
            font-size: 14px;
        }
    }
}
</style>